// extracted by mini-css-extract-plugin
export default {"pasek":"PrzewijanieTabeli_pasek__q-Mth","podpowiedz":"PrzewijanieTabeli_podpowiedz__eVIcT","przycisk":"PrzewijanieTabeli_przycisk__hmDnl"};